import { put, call, takeEvery, all, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { get } from 'lodash';
import {
  PEN_REGISTER_REQUEST,
  CREATE_BUNDLE_REQUEST,
  EDIT_BUNDLE_REQUEST,
  PRODUCTS_REQUEST,
  CREATE_PRODUCT_REQUEST,
  EDIT_PRODUCT_REQUEST,
  DISABLE_PRODUCTS_REQUEST,
  PROVIDERS_REQUEST,
  PROVIDER_PRODUCTS_REQUEST,
  SET_PEN_CONFIG_REQUEST,
  INIT_PEN_CONFIG_REQUEST,
  GET_AVAIL_PRODUCTS_FOR_BUNDLE_REQUEST,
  ADD_PROVIDER_TO_DEALER_REQUEST,
  REGISTER_PRODUCT_AND_GET_COVERAGES_REQUEST,
  REGISTER_PROVIDER_DEALER_CODE_REQUEST,
  GET_COVERAGES_AND_DEDUCTIBLES_REQUEST,
} from './actionTypes';
import {
  registerDealerSuccess,
  registerDealerFailure,
  getProvidersSuccess,
  getProvidersFailure,
  getProductsSuccess,
  getProviderProductsFailure,
  getProviderProductsSuccess,
  getProductsFailure,
  getCoveragesAndDeductiblesSuccess,
  getCoveragesAndDeductiblesFailure,
  editProductSuccess,
  editProductFailure,
  disableProductsSuccess,
  disableProductsFailure,
  createProductSuccess,
  createProductFailure,
  getAvailProductsForBundleSuccess,
  getAvailProductsForBundleFailure,
  setPenConfigSuccess,
  setPenConfigFailure,
  addProviderToDealerSuccess,
  addProviderToDealerFailure,
  createBundleSuccess,
  createBundleFailure,
  editBundleSuccess,
  editBundleFailure,
  registerProductAndGetCoveragesSuccess,
  registerProductAndGetCoveragesFailure,
  registerProviderDealerCodeSuccess,
  registerProviderDealerCodeFailure,
} from './actions';
import { getDealer as getDealerSelector } from '../dealers/selectors';
import PenService from '../../services/PenService';
import DealerService from '../../services/DealerService';
import { dealerRequest } from '../dealers/actions';
import { protectionPlanSource } from '../../util/constants';
import { PenProtectionPlanSourceTypes } from '../../components/ProtectionPlansPen/ProtectionPlansConstants';

export function* registerDealer(action) {
  const { dealer, route } = action.payload;
  try {
    const registeredDealer = yield call(PenService.registerDealer, dealer.id);
    try {
      registeredDealer.protectionPlanSource = protectionPlanSource.PEN;
      yield call(DealerService.updateDealer(registeredDealer));
    } catch (error) {
      yield put(registerDealerFailure(error));
    }
    yield put(registerDealerSuccess(registeredDealer));
    yield put(dealerRequest({ dealerId: registeredDealer.id }));
    yield put(push(route));
  } catch (error) {
    yield put(registerDealerFailure(error));
  }
}

export function* getProviders() {
  try {
    const list = yield call(PenService.getProviders);
    yield put(getProvidersSuccess(list));
  } catch (error) {
    yield put(getProvidersFailure(error));
  }
}

export function* getProviderProducts(action) {
  const { provider } = action.payload;
  try {
    const list = yield call(PenService.getProviderProducts, {
      providerId: provider.id,
    });
    yield put(getProviderProductsSuccess(list));
  } catch (error) {
    yield put(getProviderProductsFailure(error));
  }
}

export function* addProviderToDealer(action) {
  const { dealerId, providerId, providerDealerCode, name } = action.payload;
  try {
    const list = yield call(PenService.addProviderToDealer, {
      dealerId,
      providerId,
      providerDealerCode,
      name,
    });
    yield put(addProviderToDealerSuccess(list));
    yield put(dealerRequest({ dealerId }));
  } catch (error) {
    yield put(addProviderToDealerFailure(error));
  }
}

export function* getProducts() {
  try {
    const list = yield call(PenService.getProducts);
    yield put(getProductsSuccess(list));
  } catch (error) {
    yield put(getProductsFailure(error));
  }
}

export function* getCoveragesAndDeductibles(action) {
  const {
    dealerId,
    providerDealerCode,
    productDealerCode,
    productId,
    conditionFinanceTypes,
    providerId,
    rateBookCode,
    conditionInputValuesForCoverage,
    purchaseTerm,
  } = action.payload;
  try {
    yield call(PenService.registerProduct, {
      dealerId,
      productId,
      providerDealerCode,
      productDealerCode,
    });
    const coverages = yield call(PenService.getCoveragesAndDeductibles, {
      dealerId,
      productId,
      conditionFinanceTypes,
      providerId,
      rateBookCode,
      conditionInputValuesForCoverage,
      purchaseTerm,
    });
    yield put(getCoveragesAndDeductiblesSuccess({ coverages }));
  } catch (error) {
    yield put(getCoveragesAndDeductiblesFailure(error));
  }
}

export function* createProduct(action) {
  const { dealerId, formData } = action.payload;
  try {
    const response = yield call(PenService.createProduct, {
      dealerId,
      formData,
    });
    yield put(createProductSuccess(response));
    yield put(dealerRequest({ dealerId }));
  } catch (error) {
    yield put(createProductFailure(error));
  }
}

export function* editProduct(action) {
  const { dealerId, formData, productId } = action.payload;
  try {
    const response = yield call(PenService.editProduct, {
      dealerId,
      formData,
      productId,
    });
    yield put(editProductSuccess(response));
    yield put(dealerRequest({ dealerId }));
  } catch (error) {
    yield put(editProductFailure(error));
  }
}

export function* disableProducts(action) {
  const { dealerId, products } = action.payload;
  try {
    const allProducts = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < products.length; i++) {
      const payload = {
        dealerId,
        formData: products[i].formData,
        productId: products[i].productId,
      };
      allProducts.push(yield call(PenService.editProduct, payload));
    }
    const resp = yield all(allProducts);
    yield put(disableProductsSuccess(resp));
    yield put(dealerRequest({ dealerId }));
  } catch (error) {
    yield put(disableProductsFailure(error));
  }
}

export function* createBundle(action) {
  const { dealerId, bundle, formData, condition, financeType } = action.payload;
  try {
    const response = yield call(PenService.createBundle, {
      formData,
      dealerId,
      bundle,
      condition,
      financeType,
    });
    yield put(createBundleSuccess(response));
    yield put(dealerRequest({ dealerId }));
  } catch (error) {
    yield put(createBundleFailure(error));
  }
}

export function* editBundle(action) {
  const { dealerId, formData, bundleId, condition, financeType } =
    action.payload;
  try {
    const response = yield call(PenService.editBundle, {
      formData,
      dealerId,
      bundleId,
      condition,
      financeType,
    });
    yield put(editBundleSuccess(response));
    yield put(dealerRequest({ dealerId }));
  } catch (error) {
    yield put(editBundleFailure(error));
  }
}

export function* setPenConfig(action) {
  const { penConfig } = action.payload;
  try {
    yield put(setPenConfigSuccess(penConfig));
  } catch (error) {
    yield put(setPenConfigFailure(error));
  }
}

const mapPenProducts = (products) => {
  const map = {};
  products.forEach((p) => {
    map[p.id] = p;
  });
  return map;
};

export function* initPenConfig(action) {
  const dealer = yield action.payload?.dealer || select(getDealerSelector);
  try {
    const penConfig = {
      protectionPlanSource:
        dealer.protectionPlanSource || protectionPlanSource.STATIC,
      products: dealer.penProducts || [],
      providers: get(dealer, 'penConfig.providers', []),
      availableProductsForBundle: [],
      productMap: mapPenProducts(dealer.penProducts || []),
    };
    if (dealer.penConfig) {
      penConfig.enableInUI = dealer.penConfig.enableInUI || {
        products: true,
        bundles: true,
      };
      penConfig.multiBundlesInDeal =
        dealer.penConfig.multiBundlesInDeal || false;
      penConfig.hideProductPrices = dealer.penConfig.hideProductPrices || false;
      penConfig.productListFilter = dealer.penConfig.productListFilter || null;
      penConfig.showTotalCost = dealer.penConfig.showTotalCost || false;
      penConfig.showDailyPrice = dealer.penConfig.showDailyPrice || false;
      penConfig.useSelectedOfferTermsAndMiles =
        dealer.penConfig.useSelectedOfferTermsAndMiles || false;
    }
    yield put(setPenConfigSuccess(penConfig));
  } catch (error) {
    yield put(setPenConfigFailure(error));
  }
}

const productIsAvailable = (p, bundle, condition, financeType) => {
  if (
    !p.enabled ||
    !p.displayName ||
    !p.availability?.[condition]?.[financeType] ||
    (p.source === PenProtectionPlanSourceTypes.PROVIDER &&
      (!p.coverageNamesAndDeductibles?.[condition]?.[financeType] ||
        !p.coverageNamesAndDeductibles?.[condition]?.[financeType]
          .coverageName))
  ) {
    return false;
  }
  if (
    bundle.productIds &&
    bundle.productIds.length > 0 &&
    bundle.productIds.some((bundledProductId) => bundledProductId === p.id)
  ) {
    return false;
  }
  if (
    bundle.excludedProductIds &&
    bundle.excludedProductIds.length > 0 &&
    bundle.excludedProductIds.some(
      (bundledProductId) => bundledProductId === p.id,
    )
  ) {
    return false;
  }
  return true;
};

const setAvailableProductsForBundle = (
  products,
  bundle,
  condition,
  financeType,
) => {
  if (!products) {
    products = [];
  }
  return products.filter((p) =>
    productIsAvailable(p, bundle, condition, financeType),
  );
};

export function* getAvailableProductsForBundle(action) {
  const { dealerId, bundle, condition, financeType } = action.payload;
  try {
    const dealer = yield call(DealerService.getDealer, dealerId);
    const availableProductsForBundle = setAvailableProductsForBundle(
      dealer.penProducts,
      bundle,
      condition,
      financeType,
    );
    const penConfig = {
      protectionPlanSource: dealer.protectionPlanSource,
      providers: dealer.penConfig.providers,
      products: dealer.penProducts,
      availableProductsForBundle,
      productMap: mapPenProducts(dealer.penProducts),
      enableInUI: dealer.penConfig.enableInUI || {
        products: true,
        bundles: true,
      },
      multiBundlesInDeal: dealer.penConfig.multiBundlesInDeal || false,
      showTotalCost: dealer.penConfig.showTotalCost || false,
      showDailyPrice: dealer.penConfig.showDailyPrice || false,
      productListFilter: null,
      useSelectedOfferTermsAndMiles:
        dealer.penConfig.useSelectedOfferTermsAndMiles || false,
    };
    yield put(getAvailProductsForBundleSuccess(penConfig));
  } catch (error) {
    yield put(getAvailProductsForBundleFailure(error));
  }
}

export function* registerProductAndGetCoverages(action) {
  const productId = action.payload.productId;
  try {
    const { payload } = action;
    const coverages = yield call(
      PenService.registerProductAndGetCoverages,
      payload,
    );
    yield put(registerProductAndGetCoveragesSuccess({ productId, coverages }));
  } catch (error) {
    yield put(registerProductAndGetCoveragesFailure({ error, productId }));
  }
}

export function* registerProviderDealerCode(action) {
  try {
    const { payload } = action;
    const dealer = yield call(PenService.registerProviderDealerCode, payload);
    yield put(registerProviderDealerCodeSuccess(dealer));
  } catch (error) {
    yield put(registerProviderDealerCodeFailure(error));
  }
}

export function* penSaga() {
  yield takeEvery(PEN_REGISTER_REQUEST, registerDealer);
  yield takeEvery(CREATE_BUNDLE_REQUEST, createBundle);
  yield takeEvery(EDIT_BUNDLE_REQUEST, editBundle);
  yield takeEvery(PRODUCTS_REQUEST, getProducts);
  yield takeEvery(CREATE_PRODUCT_REQUEST, createProduct);
  yield takeEvery(EDIT_PRODUCT_REQUEST, editProduct);
  yield takeEvery(DISABLE_PRODUCTS_REQUEST, disableProducts);
  yield takeEvery(PROVIDERS_REQUEST, getProviders);
  yield takeEvery(PROVIDER_PRODUCTS_REQUEST, getProviderProducts);
  yield takeEvery(SET_PEN_CONFIG_REQUEST, setPenConfig);
  yield takeEvery(INIT_PEN_CONFIG_REQUEST, initPenConfig);
  yield takeEvery(
    GET_COVERAGES_AND_DEDUCTIBLES_REQUEST,
    getCoveragesAndDeductibles,
  );
  yield takeEvery(
    GET_AVAIL_PRODUCTS_FOR_BUNDLE_REQUEST,
    getAvailableProductsForBundle,
  );
  yield takeEvery(ADD_PROVIDER_TO_DEALER_REQUEST, addProviderToDealer);
  yield takeEvery(
    REGISTER_PRODUCT_AND_GET_COVERAGES_REQUEST,
    registerProductAndGetCoverages,
  );
  yield takeEvery(
    REGISTER_PROVIDER_DEALER_CODE_REQUEST,
    registerProviderDealerCode,
  );
}
